// 공통코드 화면에서 바로가기를 고치면 헤더가 다시 읽도록 알리는 신호다.
// 둘은 서로 다른 화면 트리에 있어서 상태를 공유할 방법이 마땅치 않다.
export const HEADER_LINKS_CHANGED = 'header-links-changed';
